"use client";

import { FormField } from "@/components/ui/form";
import { RegisterOptions, useFormContext } from "react-hook-form";

export const Field = ({
  name,
  rules,
  children,
}: {
  name: string;
  rules?: RegisterOptions;
  children: React.ReactElement;
}) => {
  const { control } = useFormContext();
  return (
    <FormField
      control={control}
      name={name}
      rules={rules}
      render={() => children}
    />
  );
};
